export default __webpack_public_path__ + "static/media/error-icon.465df6be.svg";